module.exports = "/static-assets/_next/static/images/islandLogo-be5a0bc519a3e2121ba1b4c2881fee61.svg";